query LookupSupplierSearch($lookupName: String!) {
  lookupSupplierSearch(lookupName: $lookupName) {
    nodes {
      id
      _fullName
      _isAliasOriginalNameViewable
      _isAliasInvoked
      _isUpdatable
      _isApproved
      supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
        nodes {
          isPrimary
          addressLine1
          addressLine2
          cityName
          postalCode
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          telephoneNumber
          emailAddress
        }
      }
      vendorNumber
      vendorServiceRate
    }
  }
}
